import React from 'react';
import { Award, Target, Users, Zap } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Award,
      title: 'Excelencia',
      description: 'Comprometidos con la calidad en cada proyecto que realizamos'
    },
    {
      icon: Target,
      title: 'Precisión',
      description: 'Soluciones exactas para las necesidades específicas de cada cliente'
    },
    {
      icon: Users,
      title: 'Cercanía',
      description: 'Servicio personalizado y atención directa en todo momento'
    },
    {
      icon: Zap,
      title: 'Innovación',
      description: 'Tecnología actualizada y mejores prácticas de la industria'
    }
  ];

  const stats = [
    { value: '15+', label: 'Años de Experiencia' },
    { value: '500+', label: 'Clientes Satisfechos' },
    { value: '1200+', label: 'Proyectos Completados' },
    { value: '98%', label: 'Tasa de Satisfacción' }
  ];

  return (
    <section id="about" className="py-20 md:py-32 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Sobre <span className="text-red-600">Nosotros</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Somos una empresa informática especializada en brindar soluciones tecnológicas integrales
          </p>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* Left Content */}
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
              Tecnología como Aliado Estratégico
            </h3>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                En SolutionIT nos dedicamos al diseño, implementación y soporte de redes de datos y WiFi, 
                sistemas de seguridad tecnológica, desarrollo de software a medida, soporte tecnológico 
                integral y venta de equipos informáticos y tecnológicos.
              </p>
              <p>
                Nuestro enfoque está orientado a ofrecer soluciones confiables, seguras y eficientes, 
                adaptadas a las necesidades de cada cliente, apoyándonos en buenas prácticas, 
                tecnología actualizada y un servicio cercano y profesional.
              </p>
              <p>
                Trabajamos para convertir la tecnología en un aliado estratégico, aportando continuidad 
                operativa, seguridad y optimización de los recursos tecnológicos de tu empresa.
              </p>
            </div>
          </div>

          {/* Right Content - Values */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {values.map((value, index) => {
              const IconComponent = value.icon;
              return (
                <div
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300"
                >
                  <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center mb-4">
                    <IconComponent className="text-red-600" size={24} />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">{value.title}</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
